import {  useCallback, useState } from 'react'
import { flatten } from 'shared/util'
import { Button } from '@mui/material'
import { TrushIcon } from 'shared/icons'

import { FileResponse } from "shared/api"

import { FormDialog } from 'components/dialog/form'
import { ConfirmDialog } from 'components/dialog/confirm'

import { NotificationResult, useEditNotification, useDeleteNotification } from "interface/notification"
import { useNotificationForm, NotificationForm } from "../form"

type EditNotificationDialogProps = {
  notification: NotificationResult
  onClose: () => void
	onEditNotification: (result: NotificationResult, logo?: FileResponse) => void
  onDeleteNotification: (notificationId: number) => void
}
export const EditNotificationDialog = ({
  notification,
  onClose,
  onEditNotification,
  onDeleteNotification
}: EditNotificationDialogProps) => {
	const [modal, setModal] = useState<"deleteNotification" | null>(null)

  const onEditted = useCallback(
    (result: NotificationResult) => {
      onEditNotification(result)
      onClose()
    },
    [onEditNotification, onClose]
  )
  const [editNotificationState, editNotification] = useEditNotification(notification.notificationId, { onEditted })
  const form = useNotificationForm({ notification, onSubmit: editNotification })

  const onDeleted = useCallback(
    (notificationId: number) => {
      onDeleteNotification(notificationId)
      onClose()
    },
    [onDeleteNotification, onClose]
  )
  const [deleteNotificationState, deleteNotification] = useDeleteNotification({ onDeleted })

  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="お知らせを編集"
      isLoading={editNotificationState.posting}
      error={flatten([
        editNotificationState.error,
        deleteNotificationState.error
      ])}
      body={<NotificationForm {...form}/>}
      leftAction={
        <Button
          variant="contained"
          color="error"
          size="large"
          startIcon={<TrushIcon/>}
          onClick={() => setModal("deleteNotification")}
        >
          削除
        </Button>
      }
      submitLabel="保存"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    >
      {(modal === 'deleteNotification') ? (
        <ConfirmDialog
          isLoading={deleteNotificationState.posting}
          message={`${notification.title} を削除します。よろしいですか？`}
          ok={{
            label: 'はい',
            onClick: () => deleteNotification(notification.notificationId)
          }}
          cancel={{
            label: 'いいえ',
            onClick: () => setModal(null)
          }}
        />
      ) : <></>}
    </FormDialog>
  )
}
